import { call, put, all } from "redux-saga/effects";
import {
  getAnalyticsDataFailAction,
  getAnalyticsDataSuccessAction,
} from "../../Actions/Analytics/Actions";
import {
  getAnalyticsApi,
  getMissionStatusApi,
  getDurationOfDeliveryApi,
  getAccuracyOfDeliveryApi,
  getDistanceOfDeliveryApi,
} from "../../../Connections/APIs/Analytics";

export function* getAllDataSaga(action) {
  try {
    const [
      Analytics,
      DurationOfDelivery,
      AccuracyOfDelivery,
      DistanceOfDelivery,
      MissionStatus
    ] = yield all([
      call(getAnalyticsApi, action.data),
      call(
        getDurationOfDeliveryApi,
        action.data
      ),
      call(
        getAccuracyOfDeliveryApi,
        action.data
      ),
      call(
        getDistanceOfDeliveryApi,
        action.data
      ),
      call(
        getMissionStatusApi,
        action.data
      ),
      call(
        getMissionStatusApi,
        action.data
      ),
    ])
    // const Analytics = yield call(getAnalyticsApi, action.data);
    // const DurationOfDelivery = yield call(
    //   getDurationOfDeliveryApi,
    //   action.data
    // );
    // const AccuracyOfDelivery = yield call(
    //   getAccuracyOfDeliveryApi,
    //   action.data
    // );
    // const DistanceOfDelivery = yield call(
    //   getDistanceOfDeliveryApi,
    //   action.data
    // );
    // const MissionStatus = yield call(
    //   getMissionStatusApi,
    //   action.data
    // );
    const data = {
      analytics: Analytics.data,
      MissionStatus: MissionStatus.data,
      distanceOfDelivery: DistanceOfDelivery.data,
      durationOfDelivery: DurationOfDelivery.data,
      accuracyOfDelivery: AccuracyOfDelivery.data,
    };
    yield put(getAnalyticsDataSuccessAction(data));
  } catch (error) {
    yield put(getAnalyticsDataFailAction(error));
  }
}
